import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ios",
  "use": "icon-ios-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ios\"><defs><style type=\"text/css\"></style></defs><path d=\"M812.2 550.8c-7.2-96.1 56.4-156.8 116.4-199-56.4-50.6-105.4-99.5-209.1-104.5-83.6-3.4-121.8 43.8-200 45.5-72.7 1.7-67.3-52.3-218.2-37.1C170.5 269.2 55.9 390.6 65 560.9c9.1 183.8 147.3 438.3 276.3 438.3 90.9-1.7 112.7-42.1 187.3-42.1 92.7 0 114.5 50.6 187.3 40.5C841.4 980.7 959.5 797 959.5 738c-69.1-33.8-138.2-91.1-147.3-187.2z m-105.4-526C534.1 46.7 485 193.4 494.1 260.8c132.7 6.7 232.7-123.1 212.7-236z\" p-id=\"3780\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ios.svg
// module id = +yoS
// module chunks = 78